import { LineItemType } from '@ftr/contracts/type/order'

export enum RequestTypeUrlValue {
  Recordings = 'recordings',
  Transcripts = 'transcripts',
}

export const REQUEST_TYPE_TO_LINE_ITEM_TYPE: Record<RequestTypeUrlValue, LineItemType> = {
  [RequestTypeUrlValue.Recordings]: LineItemType.Audio,
  [RequestTypeUrlValue.Transcripts]: LineItemType.CertifiedTranscript,
}

export function singularRequestType(requestType: RequestTypeUrlValue): string {
  const toLower = requestType.toLowerCase()
  switch (toLower) {
    case 'recordings':
      return 'recording'
    case 'transcripts':
      return 'transcript'
    default:
      return toLower
  }
}
